import { type FunctionComponent } from 'react';
import { type IconProps } from '../types';
import { IconWrapper } from '../style';

export const TrendingUp: FunctionComponent<IconProps> = ({
  color,
  rotation,
  width = '24px',
  height = '24px',
  cursor,
}: IconProps) => (
  <IconWrapper width={width} height={height} cursor={cursor}>
    <svg
      width="100%"
      height="100%"
      xmlns="http://www.w3.org/2000/svg"
      transform={`rotate(${rotation ?? 0})`}
      fill="none"
      viewBox="0 0 38 38"
    >
      <path
        d="M26.9166 8.31253C26.2608 8.31253 25.7291 8.84419 25.7291 9.50003C25.7291 10.1559 26.2608 10.6875 26.9166 10.6875H33.5498L21.375 22.8623L14.298 15.7853C13.8343 15.3216 13.0824 15.3216 12.6186 15.7853L0.743619 27.6603C0.279871 28.1241 0.279871 28.876 0.743619 29.3397C1.20737 29.8035 1.95925 29.8035 2.423 29.3397L13.4583 18.3044L20.5353 25.3814C20.999 25.8451 21.7509 25.8451 22.2147 25.3814L35.2291 12.3669V19C35.2291 19.6559 35.7608 20.1875 36.4166 20.1875C37.0725 20.1875 37.6041 19.6559 37.6041 19V9.50003C37.6041 9.19612 37.4882 8.89221 37.2563 8.66034C37.1425 8.54649 37.0113 8.46059 36.8712 8.40264C36.7312 8.34457 36.5777 8.31253 36.4166 8.31253H26.9166Z"
        fill={color ?? 'currentColor'}
      />
    </svg>
  </IconWrapper>
);
